import {Component, OnInit, ViewChild} from '@angular/core';
import {MatPaginator} from '@angular/material/paginator';
import {MatTableDataSource} from '@angular/material/table';
import { MatSort } from '@angular/material/sort';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { LogsData } from 'src/app/model/LogsData';
import { BackOffServiceService } from 'src/app/services/back-off-service.service';
import { environment } from 'src/environments/environment';
import * as Parse from 'parse';

export interface WeightHistoryData {
  weight: string;
  date: string;
}

@Component({
  selector: 'app-weight-history',
  templateUrl: './weight-history.component.html',
  styleUrls: ['./weight-history.component.css']
})
export class WeightHistoryComponent implements OnInit {
  displayedColumns: string[] = ['weight', 'date'];
  dataSource = new MatTableDataSource<WeightHistoryData>();
  data: LogsData[];
  isHandset$: Observable<boolean> = this.breakpointObserver.observe(Breakpoints.Handset)
  .pipe(
    map(result => result.matches)
  );
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;

  constructor(
    private breakpointObserver: BreakpointObserver,
    private _bkoffService: BackOffServiceService
  ) {
    Parse.initialize(environment.PARSE_APP_ID, environment.PARSE_JS_KEY);
    (Parse as any).serverURL = environment.serverURL;
  }

  ngOnInit() {
    var WEIGHT_DATA : WeightHistoryData[] = [];

    this._bkoffService.getWeightHistory().then((res) => {
      this.data = res;
      this.data.forEach(element => {
        console.log(element.weight)
        WEIGHT_DATA.push({weight: element.weight, date: element.weightDate});
      });  
      this.dataSource = new MatTableDataSource<WeightHistoryData>(WEIGHT_DATA);
      this.dataSource.paginator = this.paginator;
      this.dataSource.sort = this.sort;
    });

  }

}
